import * as React from 'react';
import styles from '../../styles/flyouts/working_set_specifications/InteractiveSchedules.scss';
import classNames from 'classnames';
import { __, redirect } from '../../core/utils';
import ArrowDoubleRightSmallIcon from '../../assets/images/arrow-double-right-small-15x15.svg';
import * as _ from 'lodash';

const InteractiveSchedules = (props) => {
  const { data, collapsed } = props;

  return (
    <div className={classNames(styles.scroller, collapsed && styles.collapsed)}>
      {_.map(data, (row, i) => (
        <div className={styles.row} key={i}>
          <div className={styles.left} onClick={() => redirect(row.url)}>
            <span>{row.prefixed_title}</span>
            <ArrowDoubleRightSmallIcon />
          </div>
          {/* <div className={styles.right}>
            <div className={styles.date_time}>
              {dateFrom(row.datetime)}
              <br />
              {timeFrom(row.datetime)}
            </div>
          </div> */}
        </div>
      ))}
    </div>
  );
};

export default InteractiveSchedules;
